import type { z } from 'zod';

import type { JeHeadersConfigSchema } from '@/domain/jeFieldRearrangement/schemas';

/**
 * Build the config key from transaction type and RTL direction.
 * LTR (default): "ACCPAY" — backwards compatible with existing configs.
 * RTL: "ACCPAY_rtl"
 */
export const getConfigName = (transactionType: string, rtl: boolean): string =>
  rtl ? `${transactionType}_rtl` : transactionType;

export type JeHeadersConfig = z.output<typeof JeHeadersConfigSchema>;

export type JeHeadersConfigsByName = Record<string, JeHeadersConfig>;

export interface SwapCellsPayload {
  fieldNameA: string;
  pairIdA: string;
  fieldNameB: string | null;
  pairIdB: string;
}
